import axios from 'axios';
import authHeader from './auth-header';
import authHeaderFile from './auth-header-file';

import { URL_API } from './Commons';

class NotaDiariaService {

  async getAll() {
    return await axios.get(URL_API + 'notadiarias', { headers: authHeader() });
  }

  getOne(id) {
    return axios.get(URL_API + 'notadiaria/' + id, { headers: authHeader() });
  }

  insert(notadiaria) {
    return axios.post(URL_API + 'notadiaria', notadiaria, { headers: authHeader() });
  }

  update(id, notadiaria) {
    return axios.put(URL_API + 'notadiaria/' + id, notadiaria, { headers: authHeader() });
  }

  delete(id) {
    return axios.delete(URL_API + 'notadiaria/' + id, { headers: authHeader() });
  }

  sendFileImg(id, formData) {
    return axios.post(URL_API + 'notadiariaupimagem/' + id, formData, { headers: authHeaderFile() });
  }
  
  sendFilePdf(id, formData) {
    return axios.post(URL_API + 'notadiariauppdf/' + id, formData, { headers: authHeaderFile() });
  }

}

export default new NotaDiariaService();